import { useMutation, useQuery, useQueryClient } from 'react-query';
import TraitService from '../services/traitService';
import { useQueryParams } from './atoms/query-params-hook';
import axiosClient from '../http/axios-client';

export function useGetTraits(queryOptions = {}) {
  const {
    page,
    setPage,
    limit,
    setLimit,
    sort,
    setSort,
  } = useQueryParams();

  const totalEntries = useQuery([ 'traits-count' ], () => {
    return TraitService.getTotalEntriesOfCollection();
  });

  const queryKey = [ 'traits', { page, limit }];
  const queryFn = () => { return TraitService.get({ page, limit }); };

  const q = useQuery({
    queryKey,
    queryFn,
    ...queryOptions,
  });

  return {
    traits: q.data,
    traitsLoading: q.isLoading,
    traitsError: q.isError,
    count: totalEntries?.data,
    page,
    limit,
    setPage,
    setLimit,
    sort,
    setSort,
  };
}

export const useTrait = (id) => {
  const queryClient = useQueryClient();

  const {
    data: trait,
    isLoading: traitIsLoading,
  } = useQuery(
    [ 'TRAITS', id ],
    () => { return TraitService.getById(id); },
    {
      enabled: !!id,
    },
  );

  const {
    data: traitCategories,
    isLoading: traitCategoriesLoading,
  } = useQuery(
    [ 'TRAITS-CATEGORIES', id ],
    () => {
      return axiosClient.get(`trait-categories/?trait=${ id }`)
        .then((data) => {
          return data.map((d) => { return d.category; });
        });
    },
    {
      enabled: !!id,
    },
  );

  const { mutateAsync: createTraitCategory } = useMutation(
    [ 'CREATE-CATEGORY', id ],
    ({ categoryId }) => {
      return axiosClient.post('trait-categories', {
        trait: id,
        category: categoryId,
      });
    },
    {
      onSettled() {
        console.log('invalidating', [ 'TRAITS-CATEGORIES', id ]);
        return queryClient.invalidateQueries([ 'TRAITS-CATEGORIES', id ]);
      },
    },
  );

  return {
    trait,
    traitIsLoading,
    traitCategories,
    traitCategoriesLoading,
    createTraitCategory,
  };
};
